import { setMark, setMeasure } from '@atlassian/jira-common-performance/src/marks.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	fetchUIFBoardData,
	type UIFBoardCachedDataResult,
} from '@atlassian/jira-software-uif-early-script/src/index.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';

const UIF_BOARD_RESOURCE_MEASURE = 'uif-board-resource-fetch';

export default async function getUifBoardResourceData(
	context: RouterDataContext,
): Promise<UIFBoardCachedDataResult | null> {
	const {
		match: { params },
		route: { name: routeName },
	} = context;

	if (
		routeName !== 'rapidboard-board' &&
		routeName !== 'rapidboard-board-embed' &&
		routeName !== 'rapidboard-user-board' &&
		routeName !== 'servicedesk-boards' &&
		(fg('jsd_shield_weekly_view_fast_follow') ? routeName !== 'servicedesk-calendar' : true) &&
		(fg('jsm_views_inside_queues_-_main_flag')
			? routeName !== 'servicedesk-queues-practice-custom-calendar' &&
				routeName !== 'servicedesk-queues-custom-calendar' &&
				routeName !== 'servicedesk-queues-practice-custom-board' &&
				routeName !== 'servicedesk-queues-custom-board'
			: true)
	) {
		return null;
	}

	try {
		if (!params.boardId) {
			throw new Error('Assertion failed, visiting board without boardID');
		}

		setMark(prefetchApiStartMark);
		const data = await fetchUIFBoardData({
			boardId: params.boardId,
			queryParameters: context.query,
			fields:
				routeName === 'servicedesk-boards' ||
				((routeName === 'servicedesk-queues-custom-board' ||
					routeName === 'servicedesk-queues-practice-custom-board') &&
					fg('jsm_views_inside_queues_-_main_flag'))
					? ['request_type', 'status']
					: undefined,
		});
		setMark(prefetchApiReadyMark);
		setMeasure(UIF_BOARD_RESOURCE_MEASURE, prefetchApiStartMark, prefetchApiReadyMark);

		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.uif-board.getUifBoardResourceData',
				message: 'An error was thrown while prefetching UIF Board REST data',
				name: 'ResourceError',
			},
			error,
		);
	}
}
